<template>
  <div
    class="consult-common-news"
    v-if="finalList.length === 1"
    @click="
      () => {
        this.handleTrack(finalList[0])
        this.toAdPage(finalList[0])
      }
    "
  >
    <img
      :data-swiper-item="JSON.stringify(finalList[0])"
      :src="finalList[0].image | imgZip(600)"
      v-stat="'点击广告位'"
      :alt="finalList[0].title"
    />
  </div>
  <div
    v-else-if="finalList.length"
    @click="handleSwiper"
    @touchmove.stop
    class="consult-common-news"
  >
    <div v-swiper:mySwiper="swiperConfig" class="swiper" :key="finalList">
      <div class="swiper-wrapper">
        <div
          class="swiper-slide"
          v-for="(item, index) in finalList"
          :key="index"
          :title="item.title"
        >
          <img
            :data-swiper-item="JSON.stringify(item)"
            :src="item.image | imgZip(600)"
            v-stat="'banner点击-' + item.title"
            :alt="item.title"
          />
        </div>
      </div>
    </div>
    <div
      :class="[
        'consult-common-news-pagination',
        paginationType === 'bullets'
          ? 'swiper-pagination ' + paginationType
          : paginationType
      ]"
    ></div>
  </div>
</template>

<script>
import { getAdLists } from 'api/consult.js'
import { mapGetters } from 'vuex'

export default {
  props: {
    list: {
      type: Array,
      default() {
        return []
      }
    },
    name: {
      type: String
    },
    qingsuName: {
      type: String
    },
    paginationType: {
      type: String,
      default: 'fraction'
    },

    trackName: {
      type: String
    }
  },
  data() {
    return {
      nameList: [],
      qingsuNameList: []
    }
  },

  onAppWebviewShow() {
    this.mySwiper && this.mySwiper.slideNext()
  },

  mounted() {
    Promise.all([
      this.isConsultTeacher && this.name
        ? this.fetchData(this.name).then(list => {
            this.nameList = list
          })
        : Promise.resolve(),
      this.isQingtingTeacher && this.qingsuName
        ? this.fetchData(this.qingsuName).then(list => {
            this.qingsuNameList = list
          })
        : Promise.resolve()
    ]).then(() => {
      setTimeout(() => {
        this.mySwiper && this.mySwiper.update()
      }, 800)
      if (this.$listeners.initFinish) {
        return this.$emit('initFinish')
      }
    })
  },

  methods: {
    handleTrack(data) {
      if (this.trackName && data) {
        const { pageName } = this.$route.meta
        try {
          this.$trackEvent(this.trackName, {
            page_title: pageName,
            item_location:
              this.finalList.findIndex(item => item.id == data.id) + 1,
            item_name: data.title.trim(),
            item_id: data.id
          })
        } catch (error) {
          console.log(error)
        }
      }
    },
    handleSwiper(e) {
      const data = e.target.getAttribute('data-swiper-item')
      this.handleTrack(JSON.parse(data))
      try {
        data && this.toAdPage(JSON.parse(data))
      } catch (e) {
        console.log(e)
      }
    },
    handleClick() {
      this.toAdPage(this.list[this.mySwiper.realIndex])
    },

    fetchData(name) {
      return getAdLists({ name }).then(res => {
        const { code, data } = res
        if (code === 0) {
          return data
          //   if (this.$listeners.initFinish) {
          //     return this.$emit('initFinish')
          //   }
        }
      })
    }
  },

  computed: {
    ...mapGetters({
      isConsultTeacher: 'homepage/isConsultTeacher',
      isQingtingTeacher: 'homepage/isQingtingTeacher'
    }),
    sourceList() {
      let list = []
      if (
        this.qingsuNameList.length &&
        (this.currentTab.name === 'qingsu' ||
          (this.currentTab.name === 'evaluate' &&
            this.commonRateType === 'qingsu'))
      ) {
        list = this.qingsuNameList
      } else {
        list = this.nameList
      }
      return list
    },
    finalList() {
      return (this.list.length ? this.list : this.sourceList).map(v => {
        const { img } = v
        return {
          ...v,
          image: img
        }
      })
    },
    swiperConfig() {
      return {
        loop: true,
        autoplay: {
          disableOnInteraction: false
        },
        pagination: {
          el: '.consult-common-news-pagination',
          type: this.paginationType
        },
        on: {
          touchStart: () => this.$bridge.isPullRefreshEnable({ enable: 0 }),
          touchEnd: () => this.$bridge.isPullRefreshEnable({ enable: 1 })
        }
      }
    },
    currentTab() {
      return this.$store.state.homepage.currentTab
    },
    commonRateType() {
      return this.$store.state.homepage.commonRateType
    }
  }
}
</script>

<style lang="scss">
.consult-common-news {
  $radius: 30px;
  margin: 30px 30px 0 !important;
  overflow: hidden;
  display: block;
  clear: both;
  border-radius: $radius;
  position: relative;
  img {
    height: 180px;
    overflow: hidden;
    object-fit: cover;
  }

  .swiper {
    border-radius: $radius;
    transform: translate3d(0, 0, 0);
  }

  .consult-common-news-pagination {
    &.bullets {
      position: static;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 20px;
    }
    &.fraction {
      position: absolute;
      right: 11px;
      bottom: 11px;
      left: auto;
      width: 53px;
      height: 25px;
      background: rgba(33, 37, 45, 0.6);
      border-radius: 13px;

      font-size: 20px;
      color: #ffffff;
      line-height: 1.1px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .swiper-pagination-bullet {
    width: 10px;
    height: 6px;
    background: #bcc2cf;
    border-radius: 4px;
    margin: 0 7px;
  }

  .swiper-pagination-bullet-active {
    width: 18px;
    background: #6982fa;
  }
}
</style>
